import { ComponentMultiStyleConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

import getElevation, { ElevationSizes } from 'theme/elevations';

const borderRadius = '12px';

const PopoverTheme: ComponentMultiStyleConfig = {
  parts: ['popper', 'content', 'header', 'body', 'footer', 'arrow', 'closeButton'],
  baseStyle: props => ({
    popper: {},
    closeButton: {
      _light: {
        color: 'grey.lighter'
      },
      _dark: {
        color: 'silver.light'
      }
    },
    header: {
      borderTopLeftRadius: borderRadius,
      borderTopRightRadius: borderRadius
    },
    content: {
      boxShadow: getElevation(props, ElevationSizes.md),
      borderRadius,

      bg: mode('silver.lightest', 'black.lightest')(props),
      color: mode('black.lighter', 'silver.lighter')(props)
    },
    footer: {
      borderBottomLeftRadius: borderRadius,
      borderBottomRightRadius: borderRadius
    }
  }),
  defaultProps: {
    colorScheme: undefined
  }
};

export default PopoverTheme;
